module.exports = __webpack_public_path__ + "img/no_pendencies_icon.f3f286c6.svg";